import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Checkbox,
  TextField,
  Typography,
  useMediaQuery,
  Tooltip,
  IconButton,
  Stack,
} from "@mui/material";
import moment from "moment";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import DeleteIcon from "@mui/icons-material/Delete";
import { confirmAlert } from "react-confirm-alert";
import Breadcrumbs from "./BreadCrumbs";
import {
  CmpDatePickerField001V1,
  CmpTextFieldEnterV1,
} from "../../Component/Common/ToolBox/ToolBoxV1";
import "./ItemListingRequest.css";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import FilterModal from "./FilterModal";
import {
  ILSTCRA_Reverse,
  ILSTCRB_Delete,
  ILSTCRA_ILSTCRB_Update,
  ILSTCRB_GETROW,
  ILSTCRB_Items_Listing_Status_Getrow,
  ISTCR_Reason_Getrow,
} from "../../Server/ApiV2";
import { ItemListRequestRO, vRdxUserInfo } from "../../Redux/roStore";
import { Head_Set } from "./SliceItemListingDetail";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import GCToggleSearchV1 from "../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import { fExecuteAPI } from "../../Server/Apis";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

const ItemListingRequestDetail = () => {
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();

  const vMediaQuery = useMediaQuery("(max-width:400px)");
  const transObj = useSelector(
    (state) => state.SliceItemListRequest.value.Head
  );
  //Location
  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const lpoGroupDropDown = useSelector(
    (state) => state.SliceDB.value.LPO_GROUP
  );

  const initialBufferObj = {
    B_Srno: 0,
    B_Itemcd: "",
    ItemName: "",
    Old_Listing: "N",
    New_Listing: "N",
    A_Locationcsv: "",
    P_B_Narration: "",
  };

  const [bufferObject, setBufferObj] = useState(initialBufferObj);
  const [open, setOpen] = useState(false);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });
  const [Location, setLocation] = useState([]);
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [DetailData, setDetailData] = useState([]); // DetailData
  const [
    sGC_Toggle_Head_Customer_ToggleDropDowm,
    setGC_Toggle_Head_Customer_ToggleDropDowm,
  ] = useState(false);
  const [reasonAttributes, setReasonAttributes] = useState({});

  useEffect(() => {
    setLocation(vRdxuserLoc);
    fLoadDetail();
  }, []);
  const fkeyup = useCallback((e) => {
    if (e.which == 27 || e.key === "Escape") {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keyup", (e) => fkeyup(e), false);
    return () => {
      document.removeEventListener("keyup", fkeyup, false);
    };
  }, [fkeyup]);
  useEffect(() => {
    const handleClick = (event) => {
      // For vendor toggle
      if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setGC_Toggle_Head_Customer_ToggleDropDowm(false);
        }
      }
      // For item name toggle
      if (sItemToggleDropdown) {
        const itemToggleElement = event.target.closest(".toggleSearch");
        if (!itemToggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm, sItemToggleDropdown]);
  useEffect(() => {
    getReasonAttribute();
  }, []);
  const fLoadDetail = async (transid = "", isNewBtnClick = false) => {
    const obj = {
      B_Transid: isNewBtnClick ? "" : transObj?.A_Transid || transid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(obj);
    const detailRes = await ILSTCRB_GETROW(FinalObj);
    if (detailRes?.status === 200) {
      setDetailData(detailRes?.data?.ResultSet);
    }
  };
  const getReasonAttribute = async () => {
    try {
      const res = await ISTCR_Reason_Getrow();
      if (res?.status === 200) {
        setReasonAttributes(res?.data?.ResultSet || {});
        console.log(res?.data?.ResultSet,"ghjk");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDetailChange = (field, value, event = null) => {
    setBufferObj((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleItemSelection = async (ItmCd, Name1) => {
    setBufferObj((prev) => ({
      ...prev,
      B_Itemcd: ItmCd,
      ItemName: Name1,
    }));
    await fLoadItemDetail(ItmCd || "");
  };

  const handleChange = (field, value, type = "text") => {
    setBufferObj((prev) => {
      let parsedValue;

      if (type === "checkbox") {
        parsedValue = value;
      } else {
        const parsed = parseInt(value);
        parsedValue = isNaN(parsed) ? 0 : parsed;
      }

      const updated = {
        ...prev,
        [field]: parsedValue,
      };

      return updated;
    });
  };

  const handleRowClick = async (selectedRow) => {
    const narrationUid = reasonAttributes?.Listed?.find(
      (r) => r.Name1 === selectedRow.B_NarrationName
    )?.UID;
    setBufferObj((prevV) => ({
      ...prevV,
      B_Srno: selectedRow.B_Srno,
      B_Itemcd: selectedRow.B_Itemcd,
      ItemName: selectedRow.ItemName,
    }));

    setBufferObj((prevV) => ({
      ...prevV,
      // Old_Listing: selectedRow.Old_Listing === "Y",
      // New_Listing: selectedRow.New_Listing === "Y",
      P_B_Narration: selectedRow.P_B_Narration,
      ...selectedRow,
    }));
  };

  const fValidationHead = () => {
    const HeadObject = ItemListRequestRO();
    let isValid = true;
    if (HeadObject?.Head?.A_Transid === "") {
      fAlertToast("FAILED", "Trans Id should not be empty");
      return;
    }
    if (HeadObject?.Head?.A_Date === "") {
      fAlertToast("FAILED", "Date should not be empty");
      isValid = false;
      return;
    }
    if (HeadObject?.Head?.A_Location === "") {
      fAlertToast("FAILED", "Location should not be empty");
      isValid = false;
      return;
    }

    if (HeadObject?.Head?.LPOGruppen === "") {
      fAlertToast("FAILED", "LPOGruppen should not be empty");
      isValid = false;
      return;
    }

    return isValid;
  };

  const fValidationDetail = () => {
    let isValid = true;

    if (
      bufferObject.B_Itemcd === "" ||
      bufferObject.B_Itemcd == undefined ||
      bufferObject.B_Itemcd === null
    ) {
      fAlertToast("FAILED", "Item Code is required.");
      isValid = false;
      return;
    }

    if (
      bufferObject.Old_Listing === "" ||
      bufferObject.Old_Listing === undefined ||
      bufferObject.Old_Listing === null
    ) {
      fAlertToast("FAILED", `Old_DisContinued is required `);
      isValid = false;
      return;
    }

    if (
      bufferObject.New_Listing === "" ||
      bufferObject.New_Listing === undefined ||
      bufferObject.New_Listing === null
    ) {
      fAlertToast("FAILED", `New_DisContinued is required `);
      isValid = false;
      return;
    }

    return isValid;
  };

  const fSave = async (isApproved, name) => {
    const Head = ItemListRequestRO()?.Head;
    if (!fValidationHead()) return;
    if (!isApproved && !fValidationDetail()) return;
    if (bufferObject.Old_Listing === bufferObject.New_Listing && !isApproved) {
      fAlertToast("FAILED", "There is no changes made save not required");
      return;
    }
      if (!bufferObject?.P_B_Narration) {
    fAlertToast(
      "FAILED",
      " Reason is mandatory"
    );
    return;
  }
    if (isApproved) {
      if (!DetailData.length) {
        return fAlertToast("FAILED", "Save at least one line item");
      }
    }

    const { UserID } = vRdxUserInfo() || {};
    // const boolToYN = (val) => (val ? "Y" : "N");
    // const normalizeBool = (val) =>
    //   typeof val === "boolean" ? boolToYN(val) : val;

    const requestPayload = {
      A_TransId: Head?.A_Transid || 0,
      A_Date: moment(Head?.A_Date).format("MM/DD/YYYY"),
      A_Loc: Head?.A_Location,
      A_Narration: Head?.A_Narration,
      A_UserCd: UserID,
      A_Vendor: Head?.VendorCd,
      DeleteInsert: "N",
      Items: [],
      isApproved,
      A_LocationCSV: Head?.A_Locationcsv,
      A_LOPGruppen: Head?.LPOGruppen,
    };
    if (isApproved) {
      requestPayload.Items = DetailData;
      // requestPayload.Items = DetailData.map((item) => ({
      //   B_Itemcd: item.B_Itemcd,
      //   Old_Listing: normalizeBool(item.Old_Listing),
      //   New_Listing: normalizeBool(item.New_Listing),
      //   P_B_RejectDetail: item.B_RejectDetail,
      //   P_B_RejectNarration: item.P_B_RejectNarration,
      //   P_B_Narration: item.P_B_Narration,
      //}));
    } else {
      requestPayload.Items = [
        // {
        //   B_Itemcd: bufferObject.B_Itemcd,
        //   Old_Listing: normalizeBool(bufferObject.Old_Listing),
        //   New_Listing: normalizeBool(bufferObject.New_Listing),
        //   P_B_RejectDetail:
        //     DetailData.filter(
        //       (item) => item.B_Itemcd === bufferObject.B_Itemcd
        //     )[0]?.B_RejectDetail || "",
        //   P_B_RejectNarration:
        //     DetailData.filter(
        //       (item) => item.B_Itemcd === bufferObject.B_Itemcd
        //     )[0]?.P_B_RejectNarration || "",
        //   P_B_Narration: bufferObject.P_B_Narration,
        // },
        bufferObject,
      ];
    }
    const StockResponse = await ILSTCRA_ILSTCRB_Update(requestPayload);

    if (StockResponse?.status === 200) {
      fAlertToast("SUCCESS", `${name} Successfully`);
      dispatch(
        Head_Set({
          ...transObj,
          A_Transid: StockResponse.data?.ResultSet?.[0]?.A_Transid,
          A_Status: name === "Approved" ? "POST" : transObj.A_Status,
          ApproveStatus: name === "Approved" ? "ENTER" : transObj.ApproveStatus,
        })
      );
      fNewDetail();
      fLoadDetail(StockResponse.data?.ResultSet?.[0]?.A_Transid);
    }
  };

  const handleDelete = async (row) => {
    var obj = {
      B_Transid: row?.B_Transid,
      B_Itemcd: row?.B_Itemcd,
    };

    const transDelete = await ILSTCRB_Delete(obj);
    if (transDelete?.status === 200) {
      fAlertToast("SUCCESS", "Deleted Successfully");
      fNewDetail();
      fLoadDetail();
    }
  };

  const fNewHead = () => {
    dispatch(
      Head_Set({
        A_Transid: 0,
        A_Date: new Date(),
        A_Location: Location[0]?.Uid,
        Loc_Name: "",
        A_Narration: "",
        A_Status: "ENTER",
        CreatedBy: "",
        CreatedDate: "",
        VendorName: "",
        VendorCd: "",
        A_Locationcsv: "",
      })
    );
    fNewDetail("", true);
    setTimeout(() => {
      document.getElementsByName("A_Narration")[0].focus();
    }, 500);
  };
  const fNewDetail = async (id = "", isNewBtnClick = false) => {
    setBufferObj(initialBufferObj);
    await fLoadDetail(id, isNewBtnClick);
    setTimeout(() => {
      document.getElementsByName("ItemName")[0].focus();
    }, 500);
  };
  const fNew = async () => {
    if (bufferObject?.ItemName === "") {
      fNewHead();
      setTimeout(() => {
        document.getElementsByName("A_Narration")[0].focus();
      }, 600);
    } else {
      await fNewDetail();
    }
  };

  const columnGroupingModel = [
    {
      groupId: "Item Listing",
      children: [
        { field: "Old_Listing" },
        { field: "New_Listing" },
        {
          field: "B_NarrationName",
        },
      ],
    },
  ];
  const HeadObject = ItemListRequestRO();
  const fLoadItemDetail = async (ItmCd) => {
    const obj = {
      ItmCd: !!ItmCd ? ItmCd : bufferObject?.B_Itemcd,
      Loc: transObj?.A_Location,
      A_Vendor: transObj?.VendorCd,
    };

    const response = await ILSTCRB_Items_Listing_Status_Getrow(obj);

    if (response?.status === 200) {
      if (response?.data?.ResultSet.length > 0) {
        setBufferObj((prevV) => ({
          ...prevV,
          Old_Listing: response?.data?.ResultSet[0].ManualListed,
          New_Listing: response?.data?.ResultSet[0].ManualListed,
        }));
      } else {
        setBufferObj((prevV) => ({
          ...prevV,
          Old_Listing: false,
          New_Listing: false,
        }));
      }
      return response?.data?.ResultSet;
    } else {
      return [];
    }
  };

  //vendor end
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        bufferObject?.ItemName,
        transObj?.A_Location
      );
      if (vItemSearchFull.length > 0) {
        handleItemSelection(
          vItemSearchFull[0]?.ItmCd,
          vItemSearchFull[0]?.Name1
        );
        setItemToggleDropdown(false);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace" && bufferObject?.B_Itemcd) {
      //rest item code
      setBufferObj((prev) => ({
        ...prev,
        B_Itemcd: "",
        ItemName: "",
      }));
    }
  };
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };
  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        transObj?.A_Location,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGCToggleItemOnRowClick = async (e) => {
    setBufferObj((prev) => ({
      ...prev,
      B_Itemcd: "",
    }));
    handleDetailChange("B_Itemcd", e.row.ItmCd);
    handleDetailChange("ItemName", e.row.Name1);
    handleItemSelection(e.row.ItmCd, e.row.Name1);

    setItemToggleDropdown(false);
  };

  const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
    let vSeatchVendor = {
      Data: xData,
      Type: xType,
      Loc: xA_Loc,
      v_isActiveOnly: false,
    };
    const vItemSearch = await fExecuteAPI(
      "SEARCHITEM001_GETROW",
      vSeatchVendor
    );
    if (vItemSearch?.Type?.toUpperCase() == "SUCCESS") {
      let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSearchGridData(vItemSearchArr);
    } else {
      fAlertToast(
        "FAILED",
        vItemSearch?.response?.data?.message
          ? vItemSearch?.response?.data?.message // vItemSearch.response.data.message
          : "Error in SearchItem"
      );
    }
  };
  const GetItemFullSearchArr = async (xItemName, xLoc) => {
    let vItemFullSearchDataObj = {
      anyData: xItemName,
      transType: "F",
      report: "Y",
      loc: xLoc,
    };

    const vItemSearchFull = await fExecuteAPI(
      "SEARCHEXACTITEM_GETROW",
      vItemFullSearchDataObj
    );
    if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
      if (vItemSearchFull?.ResultSet?.length > 0) {
        return vItemSearchFull.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        vItemSearchFull?.Type?.response?.data?.message
          ? vItemSearchFull?.Type?.response?.data?.message
          : "Error in vItemSearchFullArr"
      );
      return [];
    }
  };
  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);

      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
    setGC_Toggle_Head_Customer_ToggleDropDowm(false);
  }, [sItemToggleDropdown]);
  const fItemToggleClick = () => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: bufferObject?.ItemName,
    }));

    if (bufferObject?.ItemName != "") {
      GetSearchItem(
        bufferObject?.ItemName,
        "Any",
        transObj?.A_Location,
        setGridSelectRowData
      );
    }

    handleClick();
  };
  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const reverseSave = async () => {
    const isHeadValid = fValidationHead();
    if (!isHeadValid) return;

    const HeadObject = ItemListRequestRO();
    const obj = {
      A_TransId: HeadObject?.Head?.A_Transid || 0,
      UserCd: vRdxUserInfo()?.UserID,
    };
    const reverseRes = await ILSTCRA_Reverse(obj);
    if (reverseRes?.status === 200) {
      fAlertToast("SUCCESS", "Reversed Successfully");
      dispatch(
        Head_Set({
          ...transObj,
          A_Status: "ENTER",
          A_Status_CM: "ENTER",
        })
      );
    } else {
      fAlertToast("FAILED", "Reverse Failed");
    }
  };
  const handleExport = () => {
    apiRef.current.exportDataAsCsv({
      getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
      includeHeaders: true,
      utf8WithBom: true,
    });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };
  const [
    sGC_Toggle_Head_Customer_SearchDropdownObj,
    setGC_Toggle_Head_Customer_SearchDropdownObj,
  ] = useState({
    Type: "Any",
    Data: "",
  });
  const [
    sGC_Toggle_Head_Customer_GridData,
    setGC_Toggle_Head_Customer_GridData,
  ] = useState([]);
  const xfGC_Toggle_Head_Customer_Toggle = useCallback(() => {
    if (sGC_Toggle_Head_Customer_ToggleDropDowm) {
      setGC_Toggle_Head_Customer_ToggleDropDowm(false);

      setGC_Toggle_Head_Customer_GridData([]);
      setGC_Toggle_Head_Customer_SearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setGC_Toggle_Head_Customer_ToggleDropDowm(true);
    }
  }, [sGC_Toggle_Head_Customer_ToggleDropDowm]);

  const fOnKeyUpVendor = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        transObj.VendorName,
        "Any",
        "C",
        "Y",
        transObj.A_Location
      );
      if (vExactSearch.length > 0) {
        dispatch(
          Head_Set({
            ...transObj,
            VendorCd: vExactSearch[0]?.AcCd,
            VendorName: vExactSearch[0]?.Name1,
          })
        );
      } else {
        fGC_Toggle_Head_Customer_Dropdown_SearchModalKey(e);
      }
    }
    if (e.key === "Backspace") {
      dispatch(
        Head_Set({
          ...transObj,
          VendorCd: "",
        })
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const fGC_Toggle_Head_Customer_Dropdown_OnKeyUp_Load = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      const vExactSearch = await Get_ToggleDropDown_Load(
        sGC_Toggle_Head_Customer_SearchDropdownObj.Data,
        sGC_Toggle_Head_Customer_SearchDropdownObj.Type,
        "C",
        "N",
        dispatch
      );
      if (vExactSearch.length > 0) {
        setGC_Toggle_Head_Customer_GridData(vExactSearch);
      } else {
        setGC_Toggle_Head_Customer_GridData([]);
      }
    }
    //   id="table-main-grid-dropdown"

    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };
  const fGC_Toggle_Head_Customer_Dropdown_SearchModalKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      setGC_Toggle_Head_Customer_SearchDropdownObj((obj) => ({
        ...obj,
        Data: transObj.VendorName,
      }));
      if (transObj.VendorName != "") {
        const vExactSearch = await Get_ToggleDropDown_Load(
          transObj.VendorName,
          "Any",
          "C",
          "N",
          transObj.A_Location
        );
        if (vExactSearch.length > 0) {
          setGC_Toggle_Head_Customer_GridData(vExactSearch);
        } else {
          setGC_Toggle_Head_Customer_GridData([]);
        }
      }
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
      xfGC_Toggle_Head_Customer_Toggle();
    }
  };
  const Get_ToggleDropDown_Load = async (
    xData = transObj?.VendorName,
    xType = "Any",
    xAcTyp = "C",
    xExact = "Y",
    A_Loc = transObj.A_Location
  ) => {
    let vLoaded_Cost_FreightObj = {
      Data: xData,
      Type: xType,
      Loc: A_Loc,
      AcTyp: xAcTyp,
      Exact: xExact,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
    const vLandedCostDropdownSearch = await fExecuteAPI(
      "AccountTransSearch_GETROW",
      FinalObj
    );
    if (vLandedCostDropdownSearch?.Type?.toUpperCase() === "SUCCESS") {
      let GridID = [];
      if (vLandedCostDropdownSearch.ResultSet.length > 0) {
        let GridID = vLandedCostDropdownSearch.ResultSet?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        return GridID;
      } else {
        return GridID;
      }
    } else {
      fAlertToast("FAILED", "Error in loading LandedCost Api");
      return [];
    }
  };

  return (
    <div className="container-fluid py-2 ">
      <Breadcrumbs />
      <Grid container spacing={{ xs: 0.5, sm: 1 }} alignItems={"flex-end"}>
        {/* Transaction Info */}
        <Grid item xs={4} sm={1.5} md={1.5}>
          <Typography>Trans ID</Typography>
          <CmpTextFieldEnterV1
            xSize="small"
            xName="Transation ID"
            xValue={transObj?.A_Transid}
            xReadOnly={true}
            xDisabled={true}
          />
        </Grid>
        <Grid item xs={8} sm={2.5} md={2}>
          <Typography>Trans Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName="A_Date"
            xValue={transObj?.A_Date}
            xOnChange={(val) =>
              dispatch(Head_Set({ ...transObj, A_Date: val?.$d ?? val }))
            }
          />
        </Grid>
        <Grid item xs={12} sm={3.5} md={2.5}>
          <Typography>Trans Location</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={transObj?.A_Location}
              name="A_Location"
              onChange={(e) =>
                dispatch(Head_Set({ ...transObj, A_Location: e.target.value }))
              }
            >
              {Location.map((loc) => (
                <MenuItem className="menuSm" key={loc.Uid} value={loc.Uid}>
                  {loc?.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4.5} md={2.5}>
          <Typography>Narration</Typography>
          <TextField
            size="small"
            value={transObj?.A_Narration}
            name="A_Narration"
            onChange={(e) =>
              dispatch(Head_Set({ ...transObj, A_Narration: e.target.value }))
            }
            fullWidth
            autoComplete="off"
          />
        </Grid>{" "}
        <Grid item xs={7} sm={3.5} md={1.5}>
          <Typography>LPO Group</Typography>
          <FormControl fullWidth size="small">
            <Select
              displayEmpty
              value={transObj?.LPOGruppen}
              onChange={(e) =>
                dispatch(Head_Set({ ...transObj, LPOGruppen: e.target.value }))
              }
              renderValue={(selected) =>
                selected
                  ? lpoGroupDropDown?.find((x) => x.UId === selected)?.Name1
                  : "Select Reason"
              }
              disabled={HeadObject?.Head?.A_Status?.toUpperCase() !== "ENTER"}
            >
              {lpoGroupDropDown?.map((opt) => (
                <MenuItem className="menuSm" key={opt.UId} value={opt.UId}>
                  {opt.Name1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/* Item Info */}
        <Grid item xs={5} sm={2.5} md={2}>
          <Typography>Item Code</Typography>
          <TextField
            value={bufferObject?.B_Itemcd}
            onChange={(e) => {
              handleDetailChange("B_Itemcd", e.target.value, e);
            }}
            sx={{
              "& .MuiInputBase-root": {
                padding: 0, // Removes outer padding
              },
              "& .MuiInputBase-input": {
                padding: "8.5px 11px", // Removes inner input padding
              },
            }}
            fullWidth
            disabled
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography>Item Name</Typography>
          <GCToggleSearchV1
            xLabelText=""
            xtabIndex="101"
            xName="B_ItmName"
            xType="text"
            xValue={bufferObject?.ItemName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((prev) => ({
                ...prev,
                B_Itemcd: "",
                // B_Barcode: "",
              }));
              // setBarcode([]);
              handleDetailChange("ItemName", e.target.value);
            }}
            xOnKeyUp={fItemSearchKey}
            xonClickbtn={fItemSearchKey}
            xrows={sGridSelectRowData}
            xcolumns={[
              { field: "id", headerName: "ID", width: 70, hide: true },
              { field: "ItmCd", headerName: "Code", width: 90 },
              { field: "Name1", headerName: "Name", flex: 1 },
              // { field: "NameFL", headerName: "NameFL", width: 90 },
            ]}
            xRowClick={fGCToggleItemOnRowClick}
            xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
            xToggle={sItemToggleDropdown}
            xData={["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"]}
            xOnChangeDropdownInput={fOnChangeItem}
            xDropdownObj={sItemSearchDropdownObj}
            xOnKeyUpDropdownInput={fOnKeyUpItem}
          />
        </Grid>{" "}
        {/* Checkbox Controls */}
        <Grid item xs={12} sm={5} md={3} display={"flex"}>
          <Box
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Box
              sx={{ width: "100%" }}
              gap={1}
              display={"flex"}
              justifyContent={"flex-start"}
              alignItems={"flex-end"}
            >
              <Box display="flex" alignItems="center" flexDirection={"row"}>
                <Typography variant="body2">Old Item</Typography>
                <Checkbox
                  sx={{
                    padding: "5px",
                  }}
                  checked={bufferObject.Old_Listing === "Y"}
                  disabled
                />
              </Box>
              <Box display="flex" alignItems="center" flexDirection={"row"}>
                <Typography variant="body2">New Item</Typography>
                <Checkbox
                  sx={{
                    padding: "5px",
                  }}
                  checked={bufferObject.New_Listing === "Y"}
                  onChange={(e) =>
                    handleChange(
                      "New_Listing",
                      e.target.checked ? "Y" : "N",
                      "checkbox"
                    )
                  }
                />
              </Box>
            </Box>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <Select
                displayEmpty
                value={bufferObject.P_B_Narration || ""}
                onChange={(e) =>
                  setBufferObj((prev) => ({
                    ...prev,
                    P_B_Narration: e.target.value,
                  }))
                }
                renderValue={(selected) =>
                  selected
                    ? reasonAttributes?.Listed?.find((x) => x.UID === selected)
                        ?.Name1
                    : "Select Reason"
                }
              >
                {reasonAttributes?.Listed?.map((opt) => (
                  <MenuItem className="menuSm" key={opt.UID} value={opt.UID}>
                    {opt.Name1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        {/* Action Buttons */}
        <Grid
          item
          xs={12}
          sm={7}
          md={5}
          display="flex"
          justifyContent="flex-end"
        >
          {/* Right: Buttons Group */}
          <Box display="flex" gap={1.2} alignItems="flex-end">
            <Button
              size="small"
              variant="contained"
              onClick={fNewHead}
              disabled={transObj?.A_Status === "POST"}
            >
              New
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={() => fSave(false, "Saved")}
              disabled={transObj?.A_Status === "POST"}
            >
              Save
            </Button>
            <Button
              size="small"
              variant="contained"
              onClick={() => {
                confirmAlert({
                  title: "Approval Confirmation",
                  message: "Are you want to Approve?",
                  buttons: [
                    {
                      className: "alertBtn",
                      label: "Yes",

                      onClick: () => {
                        fSave(true, "Approved");
                      },
                    },
                    {
                      className: "alertBtn",
                      label: "No",
                      onClick: () => "",
                    },
                  ],
                });
              }}
              disabled={transObj?.A_Status === "POST"}
            >
              Approve
            </Button>
            {HeadObject?.Head?.A_Status_CM?.toUpperCase() === "REJECT" &&
              HeadObject?.Head?.A_Status?.toUpperCase() !== "ENTER" && (
                <Button
                  size="small"
                  variant="contained"
                  color="error"
                  onClick={() => {
                    confirmAlert({
                      title: "Reverse Confirmation",
                      message: "Are you sure you want to Reverse?",
                      buttons: [
                        {
                          className: "alertBtn",
                          label: "Yes",
                          onClick: () => {
                            reverseSave();
                          },
                        },
                        {
                          className: "alertBtn",
                          label: "No",
                          onClick: () => "",
                        },
                      ],
                    });
                  }}
                >
                  Reverse
                </Button>
              )}{" "}
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      {/* Data Grid Section */}
      <Box
        sx={{
          height: { xs: "33vh", sm: "61vh", md: "65vh" },
          marginTop: { xs: "8px", md: "12px" },
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={30}
          headerHeight={40}
          hideFooter
          rows={DetailData}
          getRowId={(v) => v.B_Srno}
          columns={[
            {
              field: "delete",
              headerName: "Action",
              width: 70,
              align: "center",
              hide:
                HeadObject?.Head?.A_Status?.toUpperCase() === "ENTER"
                  ? false
                  : true,

              renderCell: (params) => (
                <DeleteIcon
                  style={{
                    cursor:
                      transObj?.A_Status === "POST" ? "not-allowed" : "pointer",
                    color: transObj?.A_Status === "POST" ? "gray" : "red",
                  }}
                  onClick={() => {
                    if (transObj?.A_Status !== "POST") {
                      confirmAlert({
                        title: "Delete",
                        message: `Are you sure you want to delete this item ? ${params.row.ItemName}`,
                        buttons: [
                          {
                            label: "Yes",
                            onClick: () => handleDelete(params.row),
                          },
                          { label: "No" },
                        ],
                      });
                    }
                  }}
                />
              ),
            },
            {
              field: "B_Itemcd",
              headerName: "Item Code",
              width: 110,
              align: "center",
            },
            {
              field: "ItemName",
              headerName: "Item Name",
              minWidth: 160,
              flex: 1,
              renderCell: (params) => (
                <div
                  style={{
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                    lineHeight: "1.4em",
                    textAlign: "left", // Explicitly enforce left-align in custom content
                    width: "100%",
                  }}
                >
                  {params.value}
                </div>
              ),
            },

            {
              field: "Old_Listing",
              headerName: "Old",
              width: 60,
              align: "center",
              cellClassName: (params) =>
                params.row.Old_Listing !== params.row.New_Listing
                  ? "cell-old"
                  : "",
            },
            {
              field: "New_Listing",
              headerName: "New",
              width: 60,
              align: "center",
              cellClassName: (params) =>
                params.row.Old_Listing !== params.row.New_Listing
                  ? "cell-new"
                  : "",
            },
            {
              field: "B_NarrationName",
              headerName: "Reason",
              width: 110,
            },

            {
              field: "B_RejectDetailName",
              headerName: "Reject Type ",
              width: 110,
            },
            {
              field: "P_B_RejectNarration",
              headerName: "Reject Narration",
              minWidth: 160,
              flex: 1,
            },
          ]}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          columnGroupingModel={columnGroupingModel}
          experimentalFeatures={{ columnGrouping: true }}
          onRowDoubleClick={(params) => handleRowClick(params.row)}
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              fontSize: "11px",
            },
            "& .MuiDataGrid-columnHeaderTitleContainer": {
              justifyContent: "center",
            },
          }}
        />
      </Box>
      {/* Master Data Modal */}
      <CycleCustomModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={vMediaQuery}
        title={`Vendor Item Search -`}
        xVendor={`VendorName : ${transObj.VendorCd} - ${transObj.VendorName}`}
        children={
          <FilterModal
            open={open}
            fLoadDetail={fLoadDetail}
            handleClose={() => setOpen(false)}
            vendor={transObj?.VendorCd}
            location={transObj?.Location}
          />
        }
      />
    </div>
  );
};

export default ItemListingRequestDetail;
